import { detectMobile, detectOS } from "../../../../_utils/detectBrowser";
import EditorExperience from "../../../InteractiveExperience";
import { getObjectByUserDataProperty } from "../../../threeUtils/TransformConversions";
import EventEmitter from "../../../utils/EventEmitter";

// import UI Components
import { UIRow, UIImage, UIPanel, UISearchbar, UITextHeader } from "../../ui.lib";
import { FloatingbarAmenityCards } from "./Floatingbar.AmenityCards";
import { FloatingbarCategories } from "./Floatingbar.Categories";
import { FloatingbarFeaturedPin } from "./Floatingbar.FeaturedPin";
import { FloatingbarLocationList } from "./Floatingbar.LocationList";

import menuDropIcon from "../../../../../assets/svgs/studio/interactiveMaps/menu-chevron.svg";
import AISparkleIcon from "../../../../../assets/svgs/studio/interactiveMaps/ai_sparkle.svg";

class Floatingbar extends EventEmitter {
    constructor(props) {
        super(props);
        this.editor = new EditorExperience();
        this.parentEle = props.dom;

        this.selectedLocationPin = null;
        this.selectedPinMesh = null;
        this.toggleDirectory = true;
        this.hideAll = true;
        this.isFLoatingBarOpen = false;

        this.activeDeviceMode = null; // "MOBILE" | "DESKTOP"

        this.editor.on("locationPinSelected", this.onLocationPinSelected);
        this.editor.on(
            "toggleInteractiveSidebar",
            this.onTopggleInteractiveSidebar
        );

        this.editor.resources.on("ready", this.detectBrowserandAddEvents);
        this.editor.on("amenityTypeSelected", this.onAmenityTypeSelected);
        this.editor.on("hasFeaturedPins", this.onHasFeaturedPins);

        this.initUI();
    }

    initUI = () => {
        this.uiContainer = new UIPanel().addClass("wsInteractiveFloatingbarMobile");
        this.uiContainer.dom.id = "wsInteractiveFloatingbarMobileID"
        this.uiContainer.setDisplay("none");
        this.uiContainer.dom.style.overflow = "visible";
        this.uiContainer.dom.style.paddingRight = "20px";

        const os = detectOS();
        if (os === "iOS") {
            this.uiContainer.dom.style.height = `${window.innerHeight * 0.35}px`;
        } else {
            this.uiContainer.dom.style.height = `${window.innerHeight * 0.25}px`;
        }

        this.staticHeader = new UIPanel().addClass(
            "wsInteractiveFloatingbarMobile__staticHeader"
        );
        this.staticHeader.dom.style.overflow = "visible";
        this.staticHeader.dom.style.paddingRight = "20px";

        const uiHeaderCont = new UIRow().addClass(
            "wsInteractiveFloatingbarMobile__headerCont"
        );
        uiHeaderCont.dom.style.display = "flex";
        uiHeaderCont.dom.style.flexDirection = "row";
        uiHeaderCont.dom.style.alignItems = "center";
        uiHeaderCont.dom.style.justifyContent = "space-between";
        uiHeaderCont.dom.style.width = "100%";
        uiHeaderCont.dom.style.gap = "15px";
        uiHeaderCont.dom.style.padding = "0 10px 0 0";
        uiHeaderCont.dom.style.margin = "0";
        uiHeaderCont.dom.style.overflow = "visible";

        const headerText = new UITextHeader("", `Browse Our Directory`).addClass(
            "wsInteractiveFloatingbarMobile__header"
        );
        headerText.dom.style.flex = "0 0 auto";
        headerText.dom.style.whiteSpace = "nowrap";
        headerText.dom.style.margin = "0";
        headerText.dom.style.lineHeight = "1";
        headerText.dom.style.width = "auto";
        headerText.dom.style.display = "inline-block";
        uiHeaderCont.addChild(headerText);

        // Add AI Search button
        const aiButtonContainer = new UIPanel()
            .addClass("wsInteractiveFloatingbarMobile__aiButton")
            .onClick(() => {
                // Toggle chatbot
                const event = new CustomEvent('toggleChatbot');
                window.dispatchEvent(event);
            });

        // Create button structure
        const buttonInner = document.createElement('div');
        buttonInner.className = 'ai-generate-button';

        // Apply inline styles for gradient border (20% smaller)
        buttonInner.style.position = 'relative';
        buttonInner.style.display = 'inline-flex';
        buttonInner.style.alignItems = 'center';
        buttonInner.style.gap = '6px';
        buttonInner.style.padding = '8px 16px';
        buttonInner.style.background = '#2a2a2a';
        buttonInner.style.borderRadius = '50px';
        buttonInner.style.transition = 'all 0.3s ease';

        // Add gradient border using pseudo-element alternative
        const borderWrapper = document.createElement('div');
        borderWrapper.style.position = 'relative';
        borderWrapper.style.padding = '2px';
        borderWrapper.style.background = 'linear-gradient(90deg, #00d4ff, #3158da, #b24bf3)';
        borderWrapper.style.borderRadius = '50px';
        borderWrapper.style.display = 'inline-flex';

        const sparkleIcon = document.createElement('img');
        sparkleIcon.src = AISparkleIcon;
        sparkleIcon.alt = 'AI';
        sparkleIcon.className = 'ai-sparkle-icon';
        sparkleIcon.style.width = '16px';
        sparkleIcon.style.height = '16px';
        sparkleIcon.style.filter = 'brightness(0) invert(1)';

        const buttonText = document.createElement('span');
        buttonText.textContent = 'AI Search';
        buttonText.className = 'ai-button-text';
        buttonText.style.color = 'white';
        buttonText.style.fontSize = '14px';
        buttonText.style.fontWeight = '500';
        buttonText.style.letterSpacing = '0.3px';

        buttonInner.appendChild(sparkleIcon);
        buttonInner.appendChild(buttonText);
        borderWrapper.appendChild(buttonInner);
        aiButtonContainer.dom.appendChild(borderWrapper);

        aiButtonContainer.dom.style.cursor = "pointer";
        aiButtonContainer.dom.style.marginLeft = "0";
        aiButtonContainer.dom.style.marginRight = "0";
        aiButtonContainer.dom.style.flexShrink = "0";
        aiButtonContainer.dom.style.display = "flex";
        aiButtonContainer.dom.style.alignItems = "center";

        // Add hover effect
        borderWrapper.addEventListener('mouseenter', () => {
            buttonInner.style.transform = 'translateY(-1px)';
            buttonInner.style.boxShadow = '0 4px 12px rgba(49, 88, 218, 0.3)';
        });
        borderWrapper.addEventListener('mouseleave', () => {
            buttonInner.style.transform = 'translateY(0)';
            buttonInner.style.boxShadow = 'none';
        });

        uiHeaderCont.addChild(aiButtonContainer);
        this.staticHeader.addChild(uiHeaderCont);

        // searchbar
        this.searchbar = new UISearchbar("Search for a Location", "", true, {
            onfocus: () => {
                const browser = detectMobile();
                this.onSearchFocus();

                if (browser) {
                    this.uiContainer.dom.style.height = "100%";
                    this.uiContainer.dom.style.overflow = "auto";
                    this.isFLoatingBarOpen = true;
                }
            },
            onback: () => {
                const browser = detectMobile();
                this.onSearchBack();

                if (browser) {
                    this.uiContainer.dom.style.height = "25%";
                    this.uiContainer.dom.style.overflow = "hidden";
                    this.isFLoatingBarOpen = false;
                }
            }
        }, 'wsInteractiveFloatingbarMobile__searchbar--bgWhite').onChange(() => this.handleSearch());
        this.searchbar.addClass("wsInteractiveFloatingbarMobile__searchbar");
        this.staticHeader.addChild(this.searchbar);

        this.uiContainer.addChild(this.staticHeader);

        // Featured Location Pins
        this.topLocationContainer = new FloatingbarFeaturedPin(this.editor);
        this.locationPinsList = new FloatingbarLocationList(this.editor);
        this.amenityPinsList = new FloatingbarAmenityCards(this.editor);
        this.categorizedPinsList = new FloatingbarCategories(this.editor);

        this.uiMyContent = new UIPanel();
        this.uiMyContent.addClass("wsInteractiveFloatingbarMobile__scrollableContent");
        this.uiMyContent.addChild(this.amenityPinsList.dom);
        this.uiMyContent.addChild(this.topLocationContainer.dom);
        this.uiMyContent.addChild(this.locationPinsList.dom);
        this.uiMyContent.addChild(this.categorizedPinsList.dom);

        this.uiDropDownCont = new UIPanel().addClass("wsInteractiveFloatingbarMobile__dropdownCont");
        this.uiDropIcon = new UIImage(menuDropIcon, "20px", "20px").addClass("wsInteractiveFloatingbarMobile__dropdownIcon")
        this.uiDropDownCont.addChild(this.uiDropIcon);
        this.uiDropDownCont.onClick(() => {
            this.toggleDirectory = !this.toggleDirectory;

            this.handleVisibility();
        });

        this.locationPinsList.dom.setDisplay("none");

        this.uiContainer.addChild(this.uiMyContent);
        this.uiContainer.addChild(this.uiDropDownCont);

        this.handleVisibility();

        this.parentEle.append(this.uiContainer.dom);
    };

    updateVisibility = (bFlag) => {
        this.activeDeviceMode = bFlag ? "MOBILE" : "DESKTOP";
        if (bFlag) {
            this.uiContainer.dom.style.display = "";
        } else {
            this.uiContainer.dom.style.display = "none";
        }
    };

    handleSearch = () => {
        const searchText = this.searchbar.getValue();
        this.locationPinsList.updateSearchText(searchText);
    };

    onSearchFocus = () => {
        if (this.toggleDirectory) {
            this.toggleDirectory = false;
            this.handleVisibility();
        }
        this.topLocationContainer.dom.setDisplay("none");
        this.amenityPinsList.dom.setDisplay("none");
        this.categorizedPinsList.dom.setDisplay("none");
        this.locationPinsList.dom.setDisplay("");
    };

    onSearchBack = () => {
        this.searchbar.setValue("");
        const searchText = this.searchbar.getValue();

        if (searchText.length === 0) {
            this.topLocationContainer.dom.setDisplay("");
            this.amenityPinsList.dom.setDisplay("");
            this.categorizedPinsList.dom.setDisplay("");
            this.locationPinsList.dom.setDisplay("none");
        }
    };

    handleVisibility = () => {
        if (this.toggleDirectory) {
            if (this.hideAll) {
                this.uiMyContent.setDisplay("none");
            } else {
                this.uiMyContent.setDisplay("");
                !this.hideAll ? this.topLocationContainer.dom.setDisplay("") : this.topLocationContainer.dom.setDisplay("none");

                this.amenityPinsList.dom.setDisplay("none");
                this.categorizedPinsList.dom.setDisplay("none");
                this.locationPinsList.dom.setDisplay("none");
            }
            this.uiDropIcon.dom.style.transform = "rotate(0deg)";
        } else {
            this.uiMyContent.setDisplay("");
            this.amenityPinsList.dom.setDisplay("");
            this.categorizedPinsList.dom.setDisplay("");
            this.locationPinsList.dom.setDisplay("none");
            this.uiDropIcon.dom.style.transform = "rotate(180deg)";
        }
    }

    onLocationPinSelected = (locationPin) => {
        if (this.editor.userIsInGettingDirectionsMode) {
            return;
        }
        if (locationPin) {
            const pinMesh = getObjectByUserDataProperty(
                this.editor.interactiveParent,
                "id",
                locationPin.id
            );
            this.selectedLocationPin = locationPin;
            this.selectedPinMesh = pinMesh;
            this.editor.camera.relocateCamera(pinMesh);
            this.editor.trigger("toggleInteractiveSidebar", [
                locationPin,
                "LOCATION_INFO",
            ]);
        }
    };

    onAmenityTypeSelected = (amenityType) => {
        this.searchbar.setValue(amenityType, true);
    }

    onTopggleInteractiveSidebar = (locationPin) => {
        if (locationPin === null && this.activeDeviceMode === "MOBILE") {
            this.uiContainer.setDisplay("");
            this.topLocationContainer.dom.setDisplay("");
            this.amenityPinsList.dom.setDisplay("");
            this.categorizedPinsList.dom.setDisplay("");
            this.locationPinsList.dom.setDisplay("none");
        } else {
            this.uiContainer.setDisplay("none");
        }
    };

    onHasFeaturedPins = (bFlag) => {
        this.hideAll = !bFlag;
        this.handleVisibility();
    }

    // detectBrowserandAddEvents = () => {
    //     const browser = detectMobile();
    //     if (browser) {
    //         const uiTouchHandler = new UIPanel().addClass("wsInteractiveFloatingbarMobile__touchHandler");
    //         this.staticHeader.addChild(uiTouchHandler);
    //         this.toggleDirectory = false;
    //         this.uiDropDownCont.setDisplay("none");
    //         this.handleVisibility();

    //         uiTouchHandler.dom.addEventListener("click", () => {
    //             if (this.isFLoatingBarOpen) {
    //                 const os = detectOS();
    //                 if (os === "iOS") {
    //                     this.uiContainer.dom.style.height = `${window.innerHeight * 0.35}px`;
    //                 } else {
    //                     this.uiContainer.dom.style.height = `${window.innerHeight * 0.25}px`;
    //                 }
    //                 this.uiContainer.dom.style.overflow = "hidden";
    //                 this.isFLoatingBarOpen = false;
    //             } else {
    //                 this.uiContainer.dom.style.height = "100%";
    //                 this.uiContainer.dom.style.overflow = "auto";
    //                 this.isFLoatingBarOpen = true;
    //             }
    //         });
    //     }
    // }

    detectBrowserandAddEvents = () => {
        const browser = detectMobile();
        // const os = detectOS();
        if (browser) {
            // Remove uiTouchHandler, use this.uiContainer.dom for drag events
            const uiTouchHandler = new UIPanel().addClass("wsInteractiveFloatingbarMobile__touchHandler");
            const uiTouchHandlerDraggableArea = new UIPanel().addClass("wsInteractiveFloatingbarMobile__touchHandlerDraggableArea");
            uiTouchHandler.addChild(uiTouchHandlerDraggableArea);
            uiTouchHandlerDraggableArea.dom.style.width = `${this.uiContainer.dom.clientWidth}px`;
            uiTouchHandlerDraggableArea.dom.style.left = `-${(this.uiContainer.dom.clientWidth - this.uiContainer.dom.clientWidth / 2) - 30}px`;

            this.uiContainer.addChild(uiTouchHandler);
            this.toggleDirectory = false;
            this.uiDropDownCont.setDisplay("none");
            this.handleVisibility();

            let startY = 0;
            let startHeight = 0;
            let dragging = false;

            uiTouchHandlerDraggableArea.dom.addEventListener("touchstart", (e) => {
                dragging = true;
                startY = e.touches[0].clientY;
                startHeight = this.uiContainer.dom.offsetHeight;
                this.uiContainer.dom.style.transition = "none";
            });

            // let debounce;
            uiTouchHandlerDraggableArea.dom.addEventListener("touchmove", (e) => {
                if (!dragging) return;
                const deltaY = e.touches[0].clientY - startY;
                let newHeight = startHeight - deltaY;
                // Clamp height between 60px and window height
                newHeight = Math.max(60, Math.min(window.innerHeight, newHeight));
                this.uiContainer.dom.style.height = `${newHeight}px`;
                this.uiContainer.dom.style.overflow = "auto";

                // if (debounce) clearTimeout(debounce);
                // debounce = setTimeout(() => {
                //     const canvas = this.editor.canvas;
                //     if (canvas) {
                //         let margin = 0;
                //         let windowHeight = window.innerHeight;
                //         let canvasHeight = windowHeight - newHeight;
                //         if (os === "Android" || os === "Linux") margin += 50;
                //         if (os === "iOS" || os === "MacOS") margin += 110;
                //         canvasHeight += margin;
                //         canvas.style.height = `${canvasHeight}px`;
                //         this.editor.sizes.height = canvasHeight;
                //         this.editor.sizes.trigger('resize');
                //     }
                // }, 500);
            });

            uiTouchHandlerDraggableArea.dom.addEventListener("touchend", () => {
                dragging = false;
                this.uiContainer.dom.style.transition = "";
            });
        }
    };
}

export { Floatingbar };
